import { useState } from "react";
import InputSet from "../layouts/ContractInputSet";
import ContractsTable from "../layouts/ContractsTable"
import { ContractFilters } from "../interfaces/Contracts.interface";
import PDFViewer from "../layouts/PDFViewer";

const SumaleasingContracts = () => {
    const today = new Date();
    const tenYearsAgo = new Date();
    tenYearsAgo.setFullYear(today.getFullYear() - 10);

    const [openModal, setOpenModal] = useState<boolean>(false);
    const [viewFile, setViewFile] = useState<string>("");

    const defaultValues:ContractFilters = {
        start_date: tenYearsAgo,
        end_date: today,
        contract_no: "",
        status: "V",
        username: "",
        from_start: "start_date"
    };

    const [formData, setFormData] = useState<ContractFilters>(defaultValues);

    const updateFilters = (formUpdated: ContractFilters) => {
        setFormData({...formUpdated});
    }

    const openView = (url: string) => {
        setViewFile(url);
        setOpenModal(true);
    }

    const closeView = () => {
        setOpenModal(false);
        setViewFile("");
    }

    return (
        <>
            <div className="my-14 lg:px-6 max-w-[95rem] mx-auto w-full flex flex-col gap-4">
                <h3 className="text-xl font-semibold">Contratos Sumaleasing</h3>
                <InputSet currentFilters={formData} onSubmit={updateFilters}/>
                <ContractsTable filters={formData} openView={openView}/>
            </div>
            <PDFViewer openModal={openModal} onClose={closeView} url={viewFile}/>
        </>
    )
}

export default SumaleasingContracts;